import {
  ViewSidebar as ViewSidebarIcon,
  ViewStream as ViewStreamIcon,
} from '@mui/icons-material';
import { Box, styled } from '@mui/material';

import { EWidgetRegion, GlassToolbar, type GlassToolbarItem } from '#shared';

import { useRegionToggle } from '../../Layout';

const PREFIX = 'TSMED-LayoutManagerToolbar';

export const layoutManagerToolbarClasses = {
  root: `${PREFIX}-root`,
};

const Root = styled(Box)(({ theme }) => ({
  [`&.${layoutManagerToolbarClasses.root}`]: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
}));

export const LayoutManagerToolbar = () => {
  const { enabledRegions, toggleRegion, layoutOptions, getOptionState } =
    useRegionToggle();

  const items: GlassToolbarItem[] = layoutOptions.map(region => {
    const { disabled, tooltip } = getOptionState(region);
    const isEnabled = enabledRegions.includes(region);

    let icon;
    switch (region) {
      case EWidgetRegion.Left:
        icon = <ViewSidebarIcon />;
        break;
      case EWidgetRegion.Center:
        icon = <ViewStreamIcon sx={{ transform: 'rotate(90deg)' }} />;
        break;
      case EWidgetRegion.Right:
        icon = <ViewSidebarIcon sx={{ transform: 'scaleX(-1)' }} />;
        break;
    }

    return {
      id: region,
      content: icon,
      active: isEnabled,
      disabled,
      tooltip: tooltip || `Toggle ${region} region`,
      onClick: () => toggleRegion(region),
    };
  });

  return (
    <Root
      className={layoutManagerToolbarClasses.root}
      // Prevent all toolbar interactions from propagating to parent
      onPointerDown={e => e.stopPropagation()}
      onPointerUp={e => e.stopPropagation()}
      onClick={e => e.stopPropagation()}
      onMouseDown={e => e.stopPropagation()}
      onMouseUp={e => e.stopPropagation()}
      onTouchStart={e => e.stopPropagation()}
      onTouchEnd={e => e.stopPropagation()}
    >
      <GlassToolbar items={items} />
    </Root>
  );
};
